import classNames from 'classnames';
import { useField } from 'formik';
import React from 'react';
import * as bd from 'react-basic-design';
import { DragDropZone } from '../basic/drag-drop-zone';
import { translate } from '../basic/text';
interface FormikFileUploadProps {
    label?: string | React.ReactNode;
    imageUrl?: string;
    name: string;
    accept?: string;
    readOnly?: boolean;
    className?: string;
}

export const FormikFileUpload = ({
    label,
    imageUrl,
    name,
    accept = 'image/*',
    className,
    readOnly,
}: FormikFileUploadProps) => {
    const [field, meta, helpers] = useField(name);

    const handleFileDrop = async (file: File) => {
        const reader = new FileReader();
        reader.onloadend = () => helpers.setValue(reader.result);
        reader.readAsDataURL(file);
    };

    return (
        <bd.FormRow
            label={typeof label === 'string' ? translate(label) : label}
            className={classNames(className, 'on-hover')}
        >
            <DragDropZone
                onFileDrop={handleFileDrop}
                accept={accept}
                className="w-100"
                imageUrl={field.value || imageUrl}
                readOnly={readOnly}
            />
        </bd.FormRow>
    );
};
